import * as React from 'react';
import './ItemCategory.scss';
import Header from '../../../common/Header';
import history from '../../../../lib/history';
import { IItemCategoryProps, IItemCategoryState, ICategory } from '../../../../interfaces/IItemCategory';
import { ProgressStatus } from '../../../../constants/GlobalConstants';
import { _getInputService } from '../../../../services/event.service';
import Loader from '../../../common/loader/Loader';

export default class ItemCategory extends React.Component<IItemCategoryProps, IItemCategoryState> {
  constructor(props: IItemCategoryProps) {
    super(props);

    this.state = {
      ProgressStatus: ProgressStatus.Init,
      Categories: []
    }
  }

  componentDidMount() {
    this.getCategories();
  }

  private getCategories(): void {
    this.setState({ ProgressStatus: ProgressStatus.Loading });
    _getInputService().then(res => {
      let filterCategories: ICategory[] = res.Items.map(
        (data: any) => {
          return {
            Title: data.Artikelgroep
          }
        });

      filterCategories = filterCategories.filter(
        (thing, i, arr) => arr.findIndex(t => t.Title === thing.Title) === i
      );

      this.setState({
        ProgressStatus: ProgressStatus.Loaded,
        Categories: filterCategories
      })
    });
  }

  private gotoItem(selectedCategory: string): void {
    let _orderBasic = history.location.state.OrderBasic;
    let _items = history.location.state.Items;
    history.push({
      pathname: '/item',
      search: `?category=${selectedCategory}`,
      state: { OrderBasic: _orderBasic, Items: _items }
    })
  }
  private onHeaderBack = () => {
    let _orderBasic = history.location.state.OrderBasic;
    let _items = history.location.state.Items;
    history.push({
      pathname: '/neworderadditems',
      state: { OrderBasic: _orderBasic, Items: _items }
    })
  }

  public render() {
    return (
      this.state.ProgressStatus != ProgressStatus.Loaded ?
        <Loader PageTitle="<b>Artikel categorie</b> scherm wordt geladen" /> :
        <div className="page">
          <Header isBackVisible={true} _onBack={this.onHeaderBack} />
          <div className="container mt-3">
            <div className="ms-Grid-row row justify-content-left">
              <h3 className="ms-Grid text-center col-md-5 form-group">Selecteer een artikelgroep</h3>
            </div>
            <div className="ms-Grid-row row justify-content-center">
              {this.state.Categories.map((category, index) => {
                return (<div className="ms-Grid text-center col-md-5 form-group cursor-pointer" onClick={() => this.gotoItem(category.Title)}>
                  <div className="outline-btn btn-block d-flex align-items-center">
                    <span className="pl-4 ms-fontSize-24 text-left">{category.Title}</span>
                  </div>
                </div>)
              })}
            </div>
          </div>
        </div>
    );
  }
}
